import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, RouterOutlet } from '@angular/router';
import { HeaderComponent, LoadingIndicatorComponent, ShellComponent } from '@mds/ngx-layout';
import { StatusComponent } from './shared/components/status/status.component';

@Component({
  standalone: true,
  imports: [
    HeaderComponent,
    LoadingIndicatorComponent,
    MatButtonModule,
    MatIconModule,
    RouterLink,
    RouterOutlet,
    ShellComponent,
    StatusComponent,
  ],
  selector: 'dev-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {}
